export const GET_PLANS = 'GET_PLANS'
export const GET_DISCOUNT_DEFINITION = 'GET_DISCOUNT_DEFINITION'
